import React, {useState, useEffect} from 'react'
import Header from "../components/Header/Header";
import '../css/specialOfferCss/specialOffer.css'
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from '../components/Footer/Footer';
import { KeyboardArrowUp } from '@mui/icons-material';
import '../css/specialOfferCss/specialOfferResponsive.css'

function SpecialOffer() {
	const [showScroll, setShowScroll] = useState(false);
	useEffect(() => {
		Fancybox.bind('[data-fancybox="single"]', {
			groupAttr: false,
		});

		return () => {
			Fancybox.destroy();
		};
	}, []);

	// Calendly modal state
	const [showCalendly, setShowCalendly] = useState(false);

	// Load Calendly widget script once
	useEffect(() => {
		if (!document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]')) {
			const s = document.createElement('script');
			s.src = 'https://assets.calendly.com/assets/external/widget.js';
			s.async = true;
			document.body.appendChild(s);
		}
	}, []);

	// Initialize Calendly inline widget when modal opens
	useEffect(() => {
		if (showCalendly) {
			const init = () => {
				if (window.Calendly && window.Calendly.initInlineWidget) {
					window.Calendly.initInlineWidget({
						url: 'https://calendly.com/jimwacksman/snapshot-videos-discussion',
						parentElement: document.querySelector('.calendly-inline-widget'),
						prefill: {},
						utm: {}
					});
				}
			};

			// If script already loaded, init immediately; otherwise wait for it
			if (window.Calendly && window.Calendly.initInlineWidget) init();
			else {
				const handler = () => init();
				window.addEventListener('Calendly:scriptLoaded', handler);
				// fallback: try init after short delay
				setTimeout(init, 800);
			}
		}
	}, [showCalendly]);

	useEffect(() => {
		const handleScroll = () => {
			const scrollY = window.scrollY;            
			const rootElement = document.getElementById("root");

			if (rootElement) {
				if (scrollY >= 70) {
					rootElement.classList.add("sticky");
				} else {
					rootElement.classList.remove("sticky");
				}
			}

			if (scrollY > 100) {
				setShowScroll(true);
			} else {
				setShowScroll(false);
			}
		};

		window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	// Simple manual carousel: one slide at a time with dots and arrows
	const videoSettings = {
		dots: true,
		arrows: false,
		infinite: true,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	};

	const testimonialSettings = {
		dots: true,
		arrows: true,
		infinite: true,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		adaptiveHeight: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 1366,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				}
			},
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	};
	
	const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

	// form state and validation
	const [form, setForm] = useState({ name: '', email: '', phone: '', company: '', message: '' });
	const [errors, setErrors] = useState({});
	const [submitting, setSubmitting] = useState(false);
	const [successMsg, setSuccessMsg] = useState('');
	const [focused, setFocused] = useState({});

	const handleFocus = (field) => setFocused(prev => ({ ...prev, [field]: true }));
	const handleBlur = (field) => setFocused(prev => ({ ...prev, [field]: false }));

	const validate = () => {
		const e = {};
		if (!form.name || form.name.trim().length < 2) e.name = 'Please enter your name.';
		if (!form.email) e.email = 'Please enter your email.';
		else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Please enter a valid email.';
		if (!form.company || form.company.trim().length < 2) e.company = 'Please enter your company.';
		if (!form.message || form.message.trim().length < 5) e.message = 'Please enter a message.';
		return e;
	}

	const handleChange = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
		setErrors({ ...errors, [e.target.name]: null });
	}

	const handleSubmit = async (ev) => {
		ev.preventDefault && ev.preventDefault();
		const e = validate();
		if (Object.keys(e).length) {
			setErrors(e);
			return;
		}
		setSubmitting(true);
		setSuccessMsg('');
		try {
			const base = `${window.location.protocol}//${window.location.hostname}:8081`;
			const resp = await fetch(`https://snapshotvideos.com/api/v1/contact/subscribe`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(form)
			});
			const data = await resp.json();
			if (resp.ok && data.success) {
				setSuccessMsg('Thanks! Your submission has been received.');
				setForm({ name: '', email: '', phone: '', company: '', message: '' });
			} else {
				setErrors({ submit: data.message || 'Submission failed.' });
			}
		} catch (err) {
			setErrors({ submit: 'Network error, please try again later.' });
			console.error(err);
		} finally {
			setSubmitting(false);
		}
	}
	

  return (

	// <>
	// </>
	<>
    <main>
		<div className="special-offer-page">
			<Header />
			{/* start-banner */}
			<section className="home banner" id="banner">
				<div className="row ">
					<div className="container">
						<div className="banne-wrap">
							<div className="banner-text wow fadeInLeft"
								style={{visibility: "visible", animationName: "fadeInLeft"}}>
								<h1>Subscribe Now & Get 2 Months <span className="red">Free</span></h1>
								<p>Subscribe before December 31<sup>st</sup> and get your two months free. No long-term contracts.
									Cancel anytime.</p>
								<a href="#0" className="btn order-btn">Sign Up Now</a>
							</div>
							<div className="banner-image desktop wow fadeInRight"
								style={{visibility: "visible", animationName: "fadeInRight"}}>
								{/* <a data-fancybox="single"
									href="https://vimeo.com/1104192197" className="popup popup-btn"></a> */}
								<img alt="banner right image" src="/images/special-offer/banner-image.png" />
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* end-banner */}

			{/* start-what-are-snap-video */}
			<section className="updated-simple-pricing-section" id="updated-simple-pricing-section">
				<div className="row ">
					<div className="container">
						<div className="updated-simple-pricing-wrap">
							<div className="title wow zoomIn" style={{visibility: "visible", animationName: "zoomIn"}}>
								<h2>Save $1,500 a Year <span className="red">With This Offer</span> </h2>
							</div>
							<div className="updated-pricing-tables"><img alt="simple price bg image"
									src="/images/special-offer/simple-price-bg-image.png" />
								<div className="content-wrap">
									<div clas="button"><h5>Lock in our year-end rate and drop your cost per video from $750 to just $625.</h5></div>
									<h3>Produce one video a month and <strong>keep $1,500 in savings.</strong></h3>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Send Us Your Newsletter and We’ll Turn it into a 90 Second Video. */}

			<section>
				<div className="container sun-letter-wrap">
					<div className="send-us-n-letter">
						<div className="img-newsletter wow fadeInLeft">
							<img src="images/special-offer/Send-Us-YourNewsletter.png" alt="Send Us Your Newsletter" />
						</div>
						<div className="content-newsletter wow fadeInRight">
							<h2>Send Us Your Newsletter and <strong>We’ll Turn it into a</strong> <span className="red">90
									Second Video.</span></h2>
						</div>
					</div>
				</div>
			</section>

			{/* Send Us Your Newsletter and We’ll Turn it into a 90 Second Video. */}

			{/*  */}

			{/* start-what-are-snap-video */}

			<section className="flexiblity-sec">
				<div className="container">
					<h2 className="wow fadeInLeft">Two Months Free + <strong>Total Flexibility</strong></h2>
					<div className="sub-box wow zoomIn">
						<h4>Subscribe now, start in January, and get 2 months <strong>free. No long-term contracts.
								Cancel anytime.</strong>
						</h4>
						<a href="#0" className="btn order-btn">Sign Up Now</a>
					</div>
				</div>
			</section>

			<section className="what-are-snap-video" id="what-are-snap-video">
				<div className="row ">
					<div className="">
						<div className="what-are-snap-video-wrap wow zoomIn">
							<div className="popup-content testtimonial-slider">
								
								<div className="popup-wrap testtimonial-item-wrap flexiblity-sec-owl">
									<Slider {...videoSettings} >
										<div className="popup-box wow fadeInLeft">
											<div className="popup-image">
												<a data-fancybox="single" href="https://vimeo.com/1085788599"
													className="popup popup-btn"></a>
												<img src="/images/special-offer/pop-up-image.jpg" alt="Nanin Snapshot You Need To Know Right Now" />
											</div>
										</div>
										<div className="popup-box wow zoomIn">
											<div className="popup-image">
												<a data-fancybox="single" href="https://vimeo.com/1085754386"
													className="popup popup-btn"></a>
												<img src="/images/special-offer/pop-up-image1.jpg" alt="American Association School Librarians" />
											</div>
										</div>
										<div className="popup-box wow fadeInRight">
											<div className="popup-image">
												<a data-fancybox="single" href="https://vimeo.com/1080643342"
													className="popup popup-btn"></a>
												<img src="/images/special-offer/pop-up-image2.jpg" alt="Asc Snapshot You Need To Know Right Now" />
											</div>
										</div>
									</Slider>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* end--what-are-snap-video */}

			{/* start-testtimonial-section */}

			<section className="testtimonial-section" id="testtimonial-section">
				<div className="row">
					<div className="container">
						<div className="testtimonial-wrap-so">
							<div className="title wow zoomIn">
								<h2>Google <span className="red">Reviews</span></h2>
							</div>
							<div className="testtimonial-slider wow fadeInLeft">
								<div className="testtimonial-item-wrap testimonial-owl" id="testimonial-owl">
									<Slider {...testimonialSettings} >
										<div className="testtimonial-item">
											<div className="testtimonial-text">
												<div className="client-wrap">
													<div className="client-name">
														<h3>Stephanie Spalding </h3>
														<p className="post">National Association of Neonatal Nurses</p>
													</div>
													<div className="client-images">
														<img src="/images/special-offer/Stephanie-Spalding-Headshot.jpg"
															alt="Stephanie Spalding Headshot" />
													</div>

												</div>
												<p> <span className="semi-colon">
														<img src="/images/special-offer/semi-color-image.png" />
													</span>Snapshot videos are the perfect way to keep our members in the
													know. They’re quick, easy to digest, and make our updates feel more
													engaging.</p>

											</div>
										</div>
										<div className="testtimonial-item">
											<div className="testtimonial-text">
												<div className="client-wrap">
													<div className="client-name">
														<h3>Jaime Rice</h3>
														<p className="post">American Society of Cytopathology</p>
													</div>
													<div className="client-images">
														<img src="/images/special-offer/Jaime-Rice-Headshot.jpeg"
															alt="Stephanie Spalding Headshot" />
													</div>

												</div>
												<p> <span className="semi-colon">
														<img src="/images/special-offer/semi-color-image.png" />
													</span>Snapshot videos capture memorable moments and highlight Society
													activities, making members feel connected and involved. They also
													provide an excellent opportunity to showcase achievements and foster a
													sense of belonging.</p>
											</div>
										</div>
										<div className="testtimonial-item">
											<div className="testtimonial-text">
												<div className="client-wrap">
													<div className="client-name">
														<h3>Shawn Sullivan</h3>
														<p className="post">American Land Title Association</p>
													</div>
													<div className="client-images">
														<img src="/images/special-offer/Shawn-Sullivan-Headshot.jpeg"
															alt="Stephanie Spalding Headshot" />
													</div>
												</div>
												<p> <span className="semi-colon">
														<img src="/images/special-offer/semi-color-image.png" />
													</span> Snapshot videos are an effective way to keep members engaged
													throughout the year, with a quick turnaround that keeps content fresh.
												</p>
											</div>
										</div>
									</Slider>
								</div>
							</div>
						</div>
					</div>
                </div>
			</section>

			{/* end-testtimonial-section */}


			{/* Reserve Your Spot */}
			<section className="reserve-your-spot" id="reserve-your-spot">
				<div className="row ">
					<div className="container">
						<div className="reserve-content-wrap">
							<div className="reserve-content wow fadeInLeft">
								<div className="title">
									<h2>Subscribe & Claim Your <span className="red">2 Months Free</span></h2>
									{/* <h2>Reserve Your Spot <span className="red">in the First 50 Club </span></h2> */}
								</div>
							</div>
							<div className="contact-form wow zoomIn">
								<form className="from-ct" method="post" id="contact-enquiryform" name="formcontact" onSubmit={handleSubmit}>
									<div className="ct-form-field-warps">
										<div className="fields-wrap sf-name-wrap">
												<div className={`input-wrap ${focused.name ? 'input_focus' : ''} ${form.name ? 'value_focus' : ''}`}>
													<label htmlFor="name">Name<span>*</span></label>
													<input type="text" id="name" name="name"
														className="form-control form-booking" value={form.name} onChange={handleChange} onFocus={() => handleFocus('name')} onBlur={() => handleBlur('name')} />
													{errors.name && <div className="field-error">{errors.name}</div>}
												</div>
										</div>
										<div className="fields-wrap sf-email-wrap">
											<div className={`input-wrap ${focused.email ? 'input_focus' : ''} ${form.email ? 'value_focus' : ''}`}>
												<label htmlFor="email">Email<span>*</span></label>
												<input type="text" id="email" name="email"
													className="form-control form-booking" value={form.email} onChange={handleChange} onFocus={() => handleFocus('email')} onBlur={() => handleBlur('email')} />
												{errors.email && <div className="field-error">{errors.email}</div>}
											</div>
										</div>
										<div className="fields-wrap sf-message-wrap">
											<div className={`input-wrap ${focused.phone ? 'input_focus' : ''} ${form.phone ? 'value_focus' : ''}`}>
												<label htmlFor="phone">Phone</label>
												<input type="text" id="phone" name="phone"
													className="form-control form-booking" value={form.phone} onChange={handleChange} onFocus={() => handleFocus('phone')} onBlur={() => handleBlur('phone')} />
											</div>
										</div>
										<div className="fields-wrap sf-number-wrap">
											<div className={`input-wrap ${focused.company ? 'input_focus' : ''} ${form.company ? 'value_focus' : ''}`}>
												<label htmlFor="company">Company<span>*</span></label>
												<input type="text" id="company" name="company"
													className="form-control form-booking" value={form.company} onChange={handleChange} onFocus={() => handleFocus('company')} onBlur={() => handleBlur('company')} />
												{errors.company && <div className="field-error">{errors.company}</div>}
											</div>
										</div>
										<div className="fields-wrap sf-textarea-wrap">
											<div className={`input-wrap ${focused.message ? 'input_focus' : ''} ${form.message ? 'value_focus' : ''}`}>
												<label htmlFor="message">Message<span>*</span></label>
												<textarea name="message" id="message" value={form.message} onChange={handleChange} onFocus={() => handleFocus('message')} onBlur={() => handleBlur('message')}></textarea>
												{errors.message && <div className="field-error">{errors.message}</div>}
											</div>
										</div>
										{/* <div className="form-field recaptcha captcha-wrap" id="recaptcha2">
											<div className="recaptcha-div"> */}

												{/*
										  <div
											className="g-recaptcha"
											data-sitekey="6LdVilcrAAAAALkaYoI4r4hJ-xeLDACQ9Ehofsfo"
										  ></div>
					*/}

												{/* <div className="g-recaptcha"
													data-sitekey="6LfjtXUrAAAAAMvg0YIQRD6D01e0rIsx2dReVFzd"></div>
											</div>
										</div>
										<script src="https://www.google.com/recaptcha/api.js" async defer></script> */}
									</div>
									<div className="google-submit enquiry-button-wrapper btn order-btn">
										<button type="submit" className="csubmit-btn1 f-submit" disabled={submitting}>{submitting ? 'Sending...' : 'Submit Now'}</button>
										{/* <input id="submit" type="submit" value="SUBMIT" className="csubmit-btn1 f-submit" name="btnsubmit1"> */}
										<div style={{display: "none"}} id="ajaxLoader" className="ajaxLoader">
											<img alt="loading" src="/images/special-offer/loader.gif" />
										</div>
									</div>
									<div className="message">
										<div className="result" style={{display: "none"}} id="result"></div>
										<div className="error" style={{display: "none"}} id="error">
											One or more fields have an error. Please check and try
											again.
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* end--Reserve Your Spot */}

			{/* schedual call section */}

			<section className="container">
				<div className="schedual-sec-wrap wow zoomIn">
					<div className="schedual-sec-inn-wrap">
						<h2>We’ll make sure you’re <span className="red">ready to go in January</span></h2>
						<p> OR </p>
                        <a href="#0" className="btn order-btn schedual-btn" onClick={(e)=>{e.preventDefault(); setShowCalendly(true);}}>Schedule A Call </a>
					</div>
				</div>
			</section>

			{/* Calendly Modal */}
			{showCalendly && (
				<div className="calendly-modal" role="dialog" aria-modal="true" style={{position:'fixed',inset:0,zIndex:3000,display:'flex',justifyContent:'center',alignItems:'stretch'}}>
					<div className="calendly-overlay" onClick={()=>setShowCalendly(false)} style={{position:'absolute',inset:0,background:'rgba(0,0,0,0.6)'}}></div>
					<div className="calendly-content" style={{position:'relative',width:'100%',height:'100vh',maxWidth:'100%',background:'#fff',borderRadius:0,overflow:'hidden',zIndex:3001}}>
						<button aria-label="Close" onClick={()=>setShowCalendly(false)} style={{position:'absolute',right:12,top:12,zIndex:3010,background:'transparent',border:'none',fontSize:28,cursor:'pointer',color:'#fff',padding:6,backgroundColor:'rgba(0,0,0,0.3)',borderRadius:6}}>✕</button>
						<div style={{height:'100%',display:'flex',flexDirection:'column'}}>
							<div style={{flex:'1 1 auto',height:'100%'}}>
								<div className="calendly-inline-widget" data-url="https://calendly.com/jimwacksman/snapshot-videos-discussion" style={{height:'100%'}}></div>
							</div>
						</div>
					</div>
				</div>
			)}

			{/* schedual call section */}
			</div>
		</main>
		<Footer />
		<a onClick={scrollToTop} id="myBtn" style={{ display: showScroll ? "flex" : "none", justifyContent: 'center', alignItems: 'center' }}><KeyboardArrowUp fontSize="large" /></a>
	</>
  )
}

export default SpecialOffer